@if (table(); as table) {
<lib-card>
	<lib-table [table]="table"></lib-table>
</lib-card>
}
